// @flow
import React from 'react';
import {imageURL, numberWithCommas} from 'lib/common';
import Button from 'components/common/Button';
import { isBrowser } from 'react-device-detect';
import './CartTemplate.scss';

type Props = {
  cart: any,
  items: any,
  goProduct: any,
  allCheckedCart: any,
  updateCheckedCart: any,
  emptyCart: any,
  updateItemCart: any,
  deleteItemCheckedCart: any,
  deleteItemCart: any,
  onOffer: any,
  onShopping: any,
  onOrder: any,
  gradeDiscount: any
};

const CartTemplate = (props: Props) => (
  <div className="CartTemplate">
    <div className="cart">
      <div className="cart-items">
        <h2>장바구니</h2>
        <table className="table">
          <thead>
            <tr>
              <th colSpan="1">
                <input
                  name="isGoing"
                  type="checkbox"
                  checked={props.cart.allChecked}
                  onChange={props.allCheckedCart}
                />
              </th>
              <th colSpan="2">상품 정보</th>
              <th>단가</th>
              <th>수량</th>
              <th>가격</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {props.cart.items.length === 0 ? (
              <tr className="cart-has-no-items">
                <td colSpan="5">
                  <p>장바구니에 상품이 하나도 없습니다.</p>
                </td>
              </tr>
            ) : (
              props.cart.items.map((item, index) => (
                <tr key={item.id} className="cart-item">
                  <td className="cart-item-checkbox">
                    <input
                      name="isGoing"
                      type="checkbox"
                      checked={item.checked}
                      onChange={() => props.updateCheckedCart(index)}
                    />
                  </td>
                  <td className="cart-item-thumbnail-container">
                    <a
                      onClick={() => props.goProduct(item.product.id)}
                      className="cart-item-name-link"
                    >
                      <img
                        src={item.product ? imageURL(item.product.thumbnail, 120, 120) : ''}
                        className="cart-item-thumbnail"
                        alt="thumbnail"
                      />
                    </a>
                  </td>
                  <td className="cart-item-name">
                    <div className="cart-item-summary">
                      <h3 className="cart-item-name">
                        {item.product ?
                          <a
                            onClick={() => props.goProduct(item.product.id)}
                            className="cart-item-name-link"
                          >
                            {item.product.name}
                          </a> :
                          '삭제된 상품'
                        }
                      </h3>
                      <ul>
                        {item.product_price && (
                          <li className="cart-item-option">
                            <span className="cart-entity-label">카탈로그 번호</span>
                            {item.product_price.part_number}
                          </li>
                        )}
                        {item.product_price && (
                          <li className="cart-item-shipping-method">
                            <span className="cart-entity-label">설명</span>
                            {item.product_price.description}
                          </li>
                        )}
                        {item.product_price && (
                          <li className="cart-item-shipping-method">
                            <span className="cart-entity-label">단위</span>
                            {item.product_price.unit}
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                  {item.price ? (
                    <td className="cart-item-unit-price">
                      <span className="cart-mobile-label">단가</span>
                      <span className="cart-item-sale-price">{numberWithCommas(item.price.sale.raw)}원</span>
                      {item.price.sale.raw !== item.price.original.raw && (
                        <span className="cart-item-compare-price">
                          {numberWithCommas(item.price.original.raw)}원
                        </span>
                      )}
                      {item.price.sale.raw !== item.price.original.raw && (
                        <span className="cart-item-discounted">(-{numberWithCommas(item.price.original.raw - item.price.sale.raw)}원)</span>
                      )}
                    </td>
                  ) : (
                    <td className="cart-item-unit-price">
                      <span className="cart-mobile-label">단가</span>
                      <span className="cart-item-sale-price">
                        {numberWithCommas(item.product_price.price)}원
                      </span>
                    </td>
                  )}
                  <td className="cart-item-quantity">
                    <span className="cart-item-quantity-value">
                      <div className="quantity-control">
                        <button 
                          type="button" 
                          className="quantity-btn minus"
                          onClick={() => {
                            if (item.quantity > 1) {
                              const event = { target: { value: item.quantity - 1 } };
                              props.updateItemCart(index, item.id, event);
                            }
                          }}
                        >
                          -
                        </button>
                        <input
                          name="itemQuantity"
                          min="1"
                          onChange={(event) => props.updateItemCart(index, item.id, event)}
                          value={item.quantity}
                          className="quantity"
                          required
                          type="text"
                          pattern="[1-9]*"
                        />
                        <button 
                          type="button" 
                          className="quantity-btn plus"
                          onClick={() => {
                            const event = { target: { value: item.quantity + 1 } };
                            props.updateItemCart(index, item.id, event);
                          }}
                        >
                          +
                        </button>
                      </div>
                    </span>
                  </td>
                  <td className="cart-item-price">
                    <span className="cart-mobile-label">가격</span>
                    <span className="cart-item-sale-price">{numberWithCommas(item.quantity * item.product_price.price)}원</span>
                    {item.product_price.price !== item.product_price.original_price && (
                      <span className="cart-item-compare-price">
                        {numberWithCommas(item.quantity * item.product_price.original_price)}원
                      </span>
                    )}
                    {item.product_price.price !== item.product_price.original_price && (
                      <span className="cart-item-discounted">(-{numberWithCommas(item.quantity * (item.product_price.original_price - item.product_price.price))}원)</span>
                    )}
                  </td>                  
                  <td className="action-delete-cart-item">
                    <span
                      className="delete-cart-item"
                      onClick={() => props.deleteItemCart(item.id)}
                    >
                      ×
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
          {!!props.cart.items.length && (
            <tfoot className="total">
              <tr className="item-total">
                <td className="total-btn" colSpan="3">
                  <Button
                    theme='outline'
                    onClick={props.deleteItemCheckedCart}
                  >
                    선택상품 삭제
                  </Button>
                  <Button
                    theme='outline'
                    onClick={props.emptyCart}
                  >
                    전체상품 삭제
                  </Button>
                </td>
                <td className="total-label" colSpan="2">
                  상품 합계
                </td>
                <td className="total-value" colSpan="2">
                  {numberWithCommas(props.cart.items
                    .filter(item => item.checked)
                    .reduce((accumulator, currentItem) => {
                      return accumulator + (currentItem.quantity * currentItem.product_price.price);
                    }, 0))
                  }원
                </td>
              </tr>
            </tfoot>
          )}
        </table>
        <div className="checkout">
          { isBrowser &&
            <Button color="gray" theme="default" className="checkout-as-offer button" onClick={props.onOffer} >
              견적서 생성
            </Button>
          }
          <Button color="gray" theme="default" className="checkout-as-shopping button" onClick={props.onShopping} >
            쇼핑 계속하기
          </Button>
          <Button className="checkout-as-order button" onClick={props.onOrder} >
            주문하기
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default CartTemplate;



// WEBPACK FOOTER //
// ./src/components/cart/CartTemplate/CartTemplate.js